import { render } from "./AnimatedCheck.vue?vue&type=template&id=f13b8452&scoped=true"
const script = {}

import "./AnimatedCheck.vue?vue&type=style&index=0&id=f13b8452&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f13b8452"

export default script